import { ErrorHandler, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { CommonModule } from '@angular/common';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { GoogleMapsModule } from '@angular/google-maps';
// import { initializeApp } from 'firebase/app';
import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService } from '@angular/fire/compat/analytics';
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { appReducer } from './store/app.state';
import 'firebase/compat/analytics';
import 'firebase/compat/messaging';
import {
  clearState,
  hydrationMetaReducer,
} from '../app/auth/state/hydration.reducer';
import { ToastrModule } from 'ngx-toastr';
import { SentryErrorHandler } from './sentry/sentry-error-handler';
import {
  NgcCookieConsentModule,
  NgcCookieConsentConfig,
} from 'ngx-cookieconsent';
import { TransactionProcessingComponent } from './click-it/create-order/cement/payment/transaction-processing/transaction-processing.component';

import {BidiModule} from '@angular/cdk/bidi';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component'
import { CarouselModule } from '@coreui/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; //NOSONAR
import { GlobalErrorHandler } from './global-error-handler.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname, // or 'your.domain.com' // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
    secure:true,
  },
  position: 'bottom-right',
  palette: {
    popup: {
      background: '#0C1638',
    },
    button: {
      background: '#ffffff',
      text: '#0C1638',
    },
  },
  theme: 'classic',
  type: 'opt-out',
};

const providersArray = environment.enableSentry
  ? [
      TranslateService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthorizationInterceptor,
        multi: true,
      },
      {
        provide: ErrorHandler,
        useClass: SentryErrorHandler,
      },
      ScreenTrackingService,
      UserTrackingService,
      provideAppInitializer(() => initializeAnalytics()())
      
    ]
  : [
      TranslateService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthorizationInterceptor,
        multi: true,
      },
      ScreenTrackingService,
      UserTrackingService,
      provideAppInitializer(() => initializeAnalytics()())
    ];

const metaReducers: MetaReducer[] = [hydrationMetaReducer, clearState];

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
export function initializeAnalytics(): () => void {
  return () => {
    const gtagScript = document.createElement('script');
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.firebase.measurementId}`;
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    window['dataLayer'] = window['dataLayer'] || [];
    window.gtag = function() { window.dataLayer.push(arguments); };

    window.gtag('js', new Date());
    window.gtag('config', environment.firebase.measurementId, {
      cookie_flags: 'SameSite=Strict;Secure',
    });
  };
}

@NgModule({
  declarations: [AppComponent, TransactionProcessingComponent,TermsAndConditionsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule, //NOSONAR
    StoreModule.forRoot(appReducer, { metaReducers }),
    StoreDevtoolsModule.instrument({
      logOnly: environment.production,
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: localStorage.getItem('languageDirection')=='ltr' ?'toast-bottom-right'  : 'toast-bottom-left',
      preventDuplicates: true,
    }),    
    AppRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    AngularFireAnalyticsModule,
    CarouselModule,
    AngularFireAnalyticsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    GoogleMapsModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  exports: [TranslateModule, GoogleMapsModule, BidiModule],
  providers: [...providersArray,provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },

  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
